import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { User } from '../models/user.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private httpClient: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  login(username: string, password: string, portal: string): Observable<any> {
    let data: string = "username=" + username + "&password=" + password + "&grant_type=password" + "&portal=" + portal;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.httpClient.post<any>(environment.apiRoot + 'token', data, { headers: reqHeader })
      .pipe(
        map(user => {
          if (user && user.access_token) {
            sessionStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);
          }
          return user;
        })
      )
  }

  logout(): void {
    sessionStorage.removeItem("currentUser");
    this.currentUserSubject.next(null);
    this.router.navigate(["../account/logout"]);
  }

  getCurrentUser(): User {
    return this.currentUserSubject.value;
  }

  getToken(): string {
    return this.getCurrentUser().access_token;
  }

  isAuthenticated(): boolean {
    if (this.getCurrentUser() && this.getCurrentUser().access_token)
      return true;
    return false;
  }

  isAuthorized(allowedRoles: string[]): boolean {
    let authenticated: boolean = false;
    if (this.isAuthenticated && allowedRoles && allowedRoles.length > 0) {
      authenticated = allowedRoles.includes(this.getCurrentUser().role);
    }
    return authenticated;
  }

  changePassword(data: any): Observable<any> {
    return this.httpClient.post<Observable<any>>(environment.apiRoot + 'api/account/changePassword', data);
  }
}
